import Tooltip, { TooltipProps } from '@mui/material/Tooltip';
import React from 'react';

export default function ScoutTooltip(props: TooltipProps) {
  return <Tooltip
    arrow
    sx={{
      '.MuiTooltip-popper': {
        pointerEvents: 'visible',
        zIndex: 2
      },
      '.MuiTooltip-arrow': {
        color: (theme) => theme.palette.secondary.main
      },
      '.MuiTooltip-tooltip': {
        backgroundColor: (theme) => theme.palette.secondary.main,
        // fontFamily: 'Source Sans Pro',
        fontSize: (theme) => theme.typography.body2.fontSize,
        color: (theme) => theme.palette.secondary.contrastText,
        textAlign: 'center',
        whiteSpace: 'pre-line',
        borderRadius: 3,
        paddingTop: 3,
        paddingBottom: 3,
        paddingRight: 6,
        paddingLeft: 6
      }
    }}
    {...props}
  />;
}
